<script lang="ts">
	type Props = {
		id: string;
		label?: string;
		value?: string;
		name?: string;
		placeholder?: string | undefined;
		error?: string | undefined;
		setValue?: (value: string) => void;
	};

	let { id, value = '', name = 'pin', error, setValue }: Props = $props();
	let inputs = $state<HTMLInputElement[]>([]);
</script>

<div class="flex justify-center gap-x-2">
	<!-- eslint-disable-next-line @typescript-eslint/no-unused-vars -->
	{#each Array(6) as _, index}
		<input
			bind:this={inputs[index]}
			{id}
			oninput={(e) => {
				const target = e.target as HTMLInputElement;
				if (target.value) {
					const v = target.value;
					const splitted = value.split('');
					splitted[index] = v;
					value = splitted.join('');
					inputs[index + 1]?.focus();
					if (setValue) {
						setValue(value);
					}
				}
			}}
			onkeydown={(e) => {
				if (e.key === 'Backspace') {
					inputs[index - 1]?.focus();
				}
			}}
			onpaste={(e) => {
				e.preventDefault();
				const v = e.clipboardData?.getData('Text');
				if (v) {
					const pattern = /^\d{1,6}$/;
					if (pattern.test(v)) {
						value = v;
						if (setValue) {
							setValue(v);
						}
					}
				}
			}}
			value={value[index]}
			autocomplete="off"
			aria-label="Pin {index + 1}"
			class="w-10 rounded-lg border border-gray-200 dark:border-slate-600 p-3 text-center appearance-none"
			type="text"
			maxlength="1"
			placeholder="-"
		/>
	{/each}
</div>
<input type="hidden" {name} {value} />
{#if error}
	<p class="text-danger text-center">{error}</p>
{/if}
